import { useState } from 'react';
import AdminRefTable from './AdminRefTable';
import AdminResolveTypes from './AdminResolveTypes';
import AdminIcaoListSync from './AdminIcaoListSync';
import { REF_DATA_CONFIGS } from './refDataConfigs';
import './Admin.css';
import './AdminReferenceData.css';

const EXTRA_TABS = [
  { key: 'resolveTypes', title: 'Resolve Types', render: () => <AdminResolveTypes /> },
  { key: 'icaoListSync', title: 'ICAOList Sync', render: () => <AdminIcaoListSync /> }
];

const SUB_TABS = [
  ...REF_DATA_CONFIGS.map(config => ({ key: config.key, title: config.title, render: () => <AdminRefTable config={config} /> })),
  ...EXTRA_TABS
];

/**
 * Admin → Reference Data: second-level tabs over the six reference tables,
 * the photo-based type resolver and the ICAOList sync.
 */
function AdminReferenceData({ initialTab = SUB_TABS[0].key }) {
  const [active, setActive] = useState(initialTab);
  const current = SUB_TABS.find(t => t.key === active) || SUB_TABS[0];

  return (
    <div className="admin-reference-data">
      <div className="admin-subtabs" role="tablist" aria-label="Reference data">
        {SUB_TABS.map(tab => (
          <button
            key={tab.key}
            type="button"
            role="tab"
            aria-selected={tab.key === current.key}
            className={`admin-subtab-button${tab.key === current.key ? ' active' : ''}`}
            onClick={() => setActive(tab.key)}
          >
            {tab.title}
          </button>
        ))}
      </div>
      {/* keyed so switching tabs remounts with fresh state */}
      <div key={current.key} role="tabpanel">
        {current.render()}
      </div>
    </div>
  );
}

export default AdminReferenceData;
